import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import request from "../../request/request";

export const createUser = createAsyncThunk('createUser', async (object, { rejectWithValue }) => {
    try {
      const response = await request('/api/v1/tenants/create-user', {
        method: 'POST',
        body: object,
        auth: true,
      });

      if (response?.error) {
        throw new Error(response.error);
      }
      
      return response;
    } catch (err) {
      toast.error(err.error || "Something went wrong!");
      return rejectWithValue(err.error || "Something went wrong!");
    }
  }
);
